import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
    REQUEST_PURCHASE_QUOTES,
    FETCH_PURCHASE_QUOTES_SUCCESS,
    FETCH_PURCHASE_QUOTES_FAILURE,
    SELECT_PURCHASE_QUOTE,
    RESET_CURRENT_PURCHASE_QUOTE,
    REQUEST_PURCHASE_QUOTE_DETAIL,
    FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
    FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_QUOTE,
    CREATE_PURCHASE_QUOTE_SUCCESS,
    CREATE_PURCHASE_QUOTE_FAILURE,
    REQUEST_PURCHASE_QUOTE_PLACE,
    PURCHASE_QUOTE_PLACE_SUCCESS,
    PURCHASE_QUOTE_PLACE_FAILURE,
    REQUEST_EDITING_PURCHASE_QUOTE,
    EDIT_PURCHASE_QUOTE_SUCCESS,
    EDIT_PURCHASE_QUOTE_FAILURE,
    REQUEST_NUM_PURCHASE_QUOTES,
    FETCH_NUM_PURCHASE_QUOTES_SUCCESS,
    FETCH_NUM_PURCHASE_QUOTES_FAILURE,
    REQUEST_DELETE_PURCHASE_QUOTE,
    DELETE_PURCHASE_QUOTE_SUCCESS,
    DELETE_PURCHASE_QUOTE_FAILURE,



} from './type'

import {
    PURCHASE_QUOTES_URL,
    NUM_PURCHASE_QUOTES_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchPurchaseQuotes() {
    return dispatch => {
        dispatch(requestPurchaseQuotes());
        return axios.get(PURCHASE_QUOTES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
        .then(response => {
          dispatch(fetchPurchaseQuotesSuccess(response));
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(fetchPurchaseQuotesFailure(err));
        });
    }
}

export function requestPurchaseQuotes() {
    return {
        type: REQUEST_PURCHASE_QUOTES,
    };
}

export function fetchPurchaseQuotesSuccess(purchaseQuotes) {
    return {
        type: FETCH_PURCHASE_QUOTES_SUCCESS,
        payload: purchaseQuotes
    };
}

export function fetchPurchaseQuotesFailure(error) {
    return {
        type: FETCH_PURCHASE_QUOTES_FAILURE,
        payload: error
    };
}


export function selectPurchaseQuote(purchaseQuote) {
    return {
        type: SELECT_PURCHASE_QUOTE,
        payload: purchaseQuote
    };
}


export function resetCurrentPurchaseQuote() {
    return {
        type: RESET_CURRENT_PURCHASE_QUOTE
    }
}

// Fetch the detail page.

export function fetchPurchaseQuoteDetail(customer_id) {
    return dispatch => {
        dispatch(requestPurchaseQuoteDetail());
        return axios.get(PURCHASE_QUOTES_URL + customer_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
        .then(response => {
          dispatch(fetchPurchaseQuoteDetailSuccess(response));
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(fetchPurchaseQuoteDetailFailure(err));
        });
    }
}

export function requestPurchaseQuoteDetail() {
    return {
        type: REQUEST_PURCHASE_QUOTE_DETAIL,
    };
}

export function fetchPurchaseQuoteDetailSuccess(purchaseQuoteDetail) {
    purchaseQuoteDetail = purchaseQuoteDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (purchaseQuoteDetail.OrderDate) purchaseQuoteDetail.OrderDate = new Date(purchaseQuoteDetail.OrderDate);
    if (purchaseQuoteDetail.ETADate) purchaseQuoteDetail.ETADate = new Date(purchaseQuoteDetail.ETADate);
    if (purchaseQuoteDetail.ReceivedDate) purchaseQuoteDetail.ReceivedDate = new Date(purchaseQuoteDetail.ReceivedDate);
    return {
        type: FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
        payload: purchaseQuoteDetail
    };
}

export function fetchPurchaseQuoteDetailFailure(error) {
    return {
        type: FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
        payload: error
    };
}

export function createPurchaseQuote({
    OrderDate,
    ETADate,
    ReceivedDate,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    ConvertItemPrice,
    Vendor_id,
    VendorNum,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentTerm_id,
    ShippingMethod,
}, Purchase_Order_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight,TotalPrice,FinalPrice) {
    Purchase_Order_Line.map(
        product => {
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PURCHASE_QUOTE });
        axios.post(PURCHASE_QUOTES_URL,
            {
                Purchase_Order_Line,
                OrderDate,
                ETADate,
                ReceivedDate,
                FinalNetWeight,
                FinalShippingWeight,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                Discount,
                ShippingCost,
                HandlingCost,
                MiscCost,
                MiscNote,
                TaxRate,
                FinalPrice,
                ConvertItemPrice,
                Vendor_id,
                VendorNum,
                Pickup_VendorDetail_id,
                Deliver_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                PaymentTerm_id,
                CRV,
                ShippingMethod,

            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createPurchaseQuoteSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createPurchaseQuoteFailure(err));
            });
    }
}

export function createPurchaseQuoteSuccess(response) {
    return {
        type: CREATE_PURCHASE_QUOTE_SUCCESS,
        payload: response,
    }
}

export function createPurchaseQuoteFailure(error) {
    return {
        type: CREATE_PURCHASE_QUOTE_FAILURE,
        payload: error
    }
}



export function purchaseQuotePlace({
    PurchaseOrder_id,
    Name,
    OrderDate,
    ETADate,
    ReceivedDate,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    PurchaseStatus,
    PaymentStatus,
    ConvertItemPrice,
    Vendor_id,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentTerm_id,
    ShippingMethod,
}, Purchase_Order_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight,TotalPrice,FinalPrice) {
  if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
  if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
  if (CarryType) CarryType = CarryType.value || CarryType || "Dry";
  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
  if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
  if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
  if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
  return dispatch => {
      dispatch({ type: REQUEST_PURCHASE_QUOTE_PLACE });
      axios.put(PURCHASE_QUOTES_URL + PurchaseOrder_id + '/place/',
      {
          Purchase_Order_Line,
          Name,
          OrderDate,
          ETADate,
          ReceivedDate,
          FinalNetWeight,
          FinalShippingWeight,
          TotalPrice,
          NoteToVendor,
          ReleaseInformation,
          CarryType,
          Discount,
          ShippingCost,
          HandlingCost,
          MiscCost,
          MiscNote,
          TaxRate,
          PurchaseStatus,
          FinalPrice,
          ConvertItemPrice,
          Vendor_id,
          Pickup_VendorDetail_id,
          Deliver_Warehouse_id,
          DispatchMethod_id,
          DispatchOutSourceContact_id,
          Purchaser_User_id,
          Modifier_User_id,
          PaymentTerm_id,
          CRV,
          ShippingMethod,
          Deliver_Warehouse_id,
      },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(purchaseQuotePlaceSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(purchaseQuotePlaceFailure(err));
          });
  }
}

export function purchaseQuotePlaceSuccess() {
    return {
        type: PURCHASE_QUOTE_PLACE_SUCCESS
    }
}

export function purchaseQuotePlaceFailure(error) {
    return {
        type: PURCHASE_QUOTE_PLACE_FAILURE,
        payload: error
    }
}

export function editPurchaseQuote({
    PurchaseOrder_id,
    Name,
    OrderDate,
    ETADate,
    ReceivedDate,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    PurchaseStatus,
    ConvertItemPrice,
    Vendor_id,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentTerm_id,
    ShippingMethod,

}, Purchase_Order_Line, TaxRate, CRV,FinalNetWeight, FinalShippingWeight,TotalPrice,FinalPrice) {

    Purchase_Order_Line.map(
        product => {
            if (product.Product_id) {
                product.Product_id = product.Product_id.value || product.Product_id;
            }
        }
    )
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
    if (PaymentTerm_id) PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_PURCHASE_QUOTE });
        axios.put((PURCHASE_QUOTES_URL + PurchaseOrder_id),
            {
                Purchase_Order_Line,
                Name,
                OrderDate,
                ETADate,
                ReceivedDate,
                FinalNetWeight,
                FinalShippingWeight,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                Discount,
                ShippingCost,
                HandlingCost,
                MiscCost,
                MiscNote,
                TaxRate,
                PurchaseStatus,
                FinalPrice,
                ConvertItemPrice,
                Vendor_id,
                Pickup_VendorDetail_id,
                Deliver_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                PaymentTerm_id,
                ShippingMethod,
                CRV,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editPurchaseQuoteSuccess());
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editPurchaseQuoteFailure(err));
            });
    }
}

export function editPurchaseQuoteSuccess() {
    return {
        type: EDIT_PURCHASE_QUOTE_SUCCESS
    }
}

export function editPurchaseQuoteFailure(error) {
    return {
        type: EDIT_PURCHASE_QUOTE_FAILURE,
        payload: error
    }
}

export function fetchNumPurchaseQuotes() {
    return dispatch => {
        dispatch(requestNumPurchaseQuotes());
        return axios.get(NUM_PURCHASE_QUOTES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchNumPurchaseQuotesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchNumPurchaseQuotesFailure(err));
            });
    }
}

export function requestNumPurchaseQuotes() {
    return {
        type: REQUEST_NUM_PURCHASE_QUOTES,
    };
}

export function fetchNumPurchaseQuotesSuccess(numPurchaseQuotes) {
    return {
        type: FETCH_NUM_PURCHASE_QUOTES_SUCCESS,
        payload: numPurchaseQuotes
    };
}

export function fetchNumPurchaseQuotesFailure(error) {
    return {
        type: FETCH_NUM_PURCHASE_QUOTES_FAILURE,
        payload: error
    }
}

export function deletePurchaseQuote(purchaseOrder_id) {
  return dispatch => {
      dispatch({type: REQUEST_DELETE_PURCHASE_QUOTE});
      return axios.delete(PURCHASE_QUOTES_URL + purchaseOrder_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(deletePurchaseQuoteSuccess());
            browserHistory.push('/purchaseQuote');
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(deletePurchaseQuoteFailure(err));
          });
  }
}

export function deletePurchaseQuoteSuccess() {
    return {
        type: DELETE_PURCHASE_QUOTE_SUCCESS
    }
}

export function deletePurchaseQuoteFailure(error) {
    return {
        type: DELETE_PURCHASE_QUOTE_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseQuotes_actions.js